// library imports
import { InfoCircleOutlined } from "@ant-design/icons";
import { Card, Col, Row } from "antd";
import { useEffect, useState } from "react";
// style imports
import "../../styles/Chatbot/Chatbot.css";
// component imports
import ChatMiddle from "../../components/chatbot/ChatMiddle";
import ChatConversation from "../../components/chatbot/ChatConversation";
// import FileTableModal from "../../components/chatbot/file/FileTableModal";
// function imports
import useGetConversationList from "../../functions/Conversation/getConversationList";
import useGetChatHistoryList from "../../functions/ChatHistory/getChatHistoryList";

export default function ChatbotPage() {
  const [activeConversation, setActiveConversation] = useState(null);

  const [refreshConversation, setRefreshConversation] = useState(true);
  const [refreshHistory, setRefreshHistory] = useState(false);

  const [fileModal, setFileModal] = useState(false);

  const { getConversationList, conversationList, conversationLoading } =
    useGetConversationList();
  const {
    getChatHistoryList,
    chatHistoryList,
    setChatHistoryList,
    historyLoading,
    changeConversation,
    setChangeConversation,
  } = useGetChatHistoryList();

  function handleChangeConversation(value) {
    setActiveConversation(value);
    setChangeConversation(value != null ? true : false);
  }

  // For handle refresh conversation list and chat history when create new conversation
  function handleRefreshConversation(key) {
    setRefreshConversation(true);
    setActiveConversation(key);
  }

  // For handle refresh chat history when create new chat history
  function handleRefreshHistory() {
    setRefreshHistory(true);
  }

  useEffect(() => {
    // If have active conversation
    if (activeConversation != null) {
      getChatHistoryList(activeConversation);
    }

    // When create new conversation clear the chat history
    if (activeConversation == null) {
      setChatHistoryList([]);
    }
  }, [activeConversation]);

  useEffect(() => {
    if (refreshHistory) {
      getChatHistoryList(activeConversation);
      setRefreshHistory(false);
    }
  }, [refreshHistory]);

  // Get conversation list base on user
  useEffect(() => {
    if (refreshConversation) {
      getConversationList();
      setRefreshConversation(false);
    }
  }, [refreshConversation]);

  return (
    <Row style={{ height: "95%" }}>
      <Col span={24}>
        {/* <Card
          style={{ height: "100%" }}
          className="insight-ai-card"
          title={"Xynersys Insight AI Chatbot"}
          extra={
            <DownloadOutlined
              onClick={() => {
                setFileModal(!fileModal);
              }}
            />
          }
          size="small"
        > */}
        <Row style={{ height: "100%" }} gutter={[12, 12]}>
          <Col xs={24} sm={24} lg={4}>
            <Card style={{ height: "100%" }}>
              <ChatConversation
                activeConversation={activeConversation}
                conversationList={conversationList}
                conversationLoading={conversationLoading}
                handleRefreshConversation={handleRefreshConversation}
                handleChangeConversation={handleChangeConversation}
              />
            </Card>
          </Col>
          <Col xs={24} sm={24} lg={20}>
            <Card
              style={{ height: "100%", maxHeight: "95vh" }}
              bodyStyle={{ height: "100%" }}
            >
              <ChatMiddle
                activeConversation={activeConversation}
                chatHistoryList={chatHistoryList}
                changeConversation={changeConversation}
                historyLoading={historyLoading}
                handleRefreshConversation={handleRefreshConversation}
                handleRefreshHistory={handleRefreshHistory}
              />
            </Card>
          </Col>
          {/* <Col xs={0} sm={0} lg={1}>
              <Flex style={{ height: "100%" }} justify="center">
                <Divider
                  type="vertical"
                  style={{ borderColor: "gray", height: "100%" }}
                />
              </Flex>
            </Col>
            <Col xs={24} sm={24} lg={0}>
              <Divider style={{ borderColor: "gray", height: "100%" }} />
            </Col>
            <Col xs={24} sm={24} lg={4}>
              <ChatThoughtChain />
            </Col> */}
        </Row>
        {/* </Card> */}
      </Col>
      {/* <FileTableModal open={fileModal} setOpen={setFileModal} /> */}
    </Row>
  );
}
